const INITIAL_RETRY_DELAY_MS = 2000;
const MAX_RETRY_DELAY_MS = 30000;
export const MAX_AUTH_SESSION_FAILURES = 3;

let meRequestInProgress = false;
let validatedAccessToken: string | undefined;
let retryDelayMs = INITIAL_RETRY_DELAY_MS;
let consecutiveFailureCount = 0;

export function getAuthSessionCache() {
  return {
    meRequestInProgress,
    validatedAccessToken,
    retryDelayMs,
    consecutiveFailureCount,
  };
}

export function setAuthSessionMeRequestInProgress(inProgress: boolean) {
  meRequestInProgress = inProgress;
}

export function markAuthSessionValidated(accessToken: string) {
  validatedAccessToken = accessToken;
  retryDelayMs = INITIAL_RETRY_DELAY_MS;
  consecutiveFailureCount = 0;
}

export function recordAuthSessionFailure(): boolean {
  consecutiveFailureCount += 1;
  return consecutiveFailureCount >= MAX_AUTH_SESSION_FAILURES;
}

export function resetAuthSessionFailureCount() {
  consecutiveFailureCount = 0;
}

export function increaseAuthSessionRetryDelay(): number {
  retryDelayMs = Math.min(retryDelayMs * 2, MAX_RETRY_DELAY_MS);
  return retryDelayMs;
}

export function getAuthSessionRetryDelay(): number {
  return retryDelayMs;
}

export function resetAuthSessionRetryDelay() {
  retryDelayMs = INITIAL_RETRY_DELAY_MS;
  consecutiveFailureCount = 0;
}

export function resetAuthSessionCache() {
  meRequestInProgress = false;
  validatedAccessToken = undefined;
  retryDelayMs = INITIAL_RETRY_DELAY_MS;
  consecutiveFailureCount = 0;
}

export { INITIAL_RETRY_DELAY_MS, MAX_RETRY_DELAY_MS };
